const FolderWindow = ({ title, files, onClose, onFileClick, header = [], toolbar = [], sidebar = [] }) => {
    return (
        <div className="absolute top-[6%] left-[7%] z-10 flex h-[510px] w-[800px] flex-col rounded-3xl bg-[#1F293770] shadow-lg backdrop-blur-[10px]">
            {/* Header */}
            <div className="flex items-center justify-between px-4">
                <div className="relative mt-4 flex items-center gap-1.5 rounded-t-[18px] bg-[#D9D9D9] p-2 px-4 opacity-85">
                    <img src="/storage/game/system-icons/mistnidiskccerny.svg" alt={title} className="h-5 w-5" />
                    <h3 className="text-lg font-semibold text-[#1F2937]">{title}</h3>
                </div>
                <div className="flex gap-1.5">
                    {header.map((btn, idx) => (
                        <button
                            key={idx}
                            onClick={() => {
                                if (btn.action === 'close') {
                                    onClose?.();
                                } else if (btn.onClick) {
                                    btn.onClick(btn.action);
                                }
                            }}
                            className={`rounded px-2 py-1 ${btn.action ? 'cursor-pointer hover:bg-white/20' : 'cursor-not-allowed opacity-50'}`}
                        >
                            <img src={btn.icon} alt={btn.label || btn.action} className="h-5 w-5" />
                        </button>
                    ))}
                </div>
            </div>

            {/* Toolbar */}
            <div className="px-4">
                <div className="flex gap-4 rounded-r-[18px] rounded-bl-[18px] bg-[#D9D9D9] px-3 py-3 opacity-85">
                    {toolbar.map((btn, idx) => (
                        <button
                            key={idx}
                            className="flex items-center gap-1 rounded px-2 py-1 text-[#1F2937] hover:bg-white/50"
                            onClick={() => btn.action && btn.onClick?.(btn.action)}
                        >
                            <img src={btn.icon} alt={btn.label} className="h-5 w-5" />
                            <span className="text-[16px]">{btn.label}</span>
                        </button>
                    ))}
                </div>
            </div>

            <div className="flex flex-1 overflow-hidden p-4">
                {/* Sidebar */}
                <div className="flex w-48 flex-col gap-1.5 rounded-[18px] bg-[#00000040] p-3 px-4 text-white">
                    {sidebar.map((item, idx) => (
                        <div key={idx}>
                            <button
                                className="flex items-center gap-2 rounded p-1 hover:bg-white/20"
                                onClick={() => item.action && item.onClick?.(item.action)}
                            >
                                <img src={item.icon} alt={item.label} className="h-5 w-5" />
                                <span className="text-[16px]">{item.label}</span>
                            </button>

                            {/* Divider */}
                            {item.divider && <hr className="my-2 border-t border-white/30" />}
                        </div>
                    ))}
                </div>

                {/* Content */}
                <div className="flex-1 overflow-y-auto p-3 text-white">
                    <div className="grid grid-cols-5 gap-4">
                        {files.map((file, idx) => (
                            // <button
                            //   key={idx}
                            //   onClick={() => onFileClick?.(file)}   // 🔹 přidáme callback
                            //   className="flex flex-col items-center hover:bg-white/10 rounded p-2 cursor-pointer"
                            // >
                            //   <img src={file.icon} alt={file.label} className="w-12 h-12" />
                            //   <span className="text-sm mt-2">{file.label}</span>
                            // </button>
                            <button
                                key={idx}
                                className="flex w-24 cursor-pointer flex-col items-center gap-1 rounded p-2 hover:bg-white/10"
                                onClick={() => onFileClick(file)}
                            >
                                <img src={file.icon} alt={file.label} className="h-10 w-10" />
                                <span className="text-center text-sm text-white">{file.label}</span>
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FolderWindow;
